module.exports = __webpack_public_path__ + "img/eniko-akos.dbe25cd3.jpg";